import { css } from '@emotion/react';

import { theme } from '@adflow/frontend/ui-theme';
import type { DataTableItemType } from '@adflow/shared/util-column-templates';

import { ListPageSelector, ListPaginationTotal } from './ListPagination';

const styles = {
	container: css({
		display: 'flex',
		justifyContent: 'space-between',
		paddingLeft: '1rem',
		paddingRight: '1rem',
		paddingTop: '0.5rem',
		paddingBottom: '1.25rem',
		flexDirection: 'column',
		alignItems: 'flex-start',

		height: '80px',
	}),
	buttonsWrap: css({ display: 'flex', alignItems: 'center' }),
	text: css({
		color: theme.colors.text.primary,
		fontWeight: '400',
	}),
	dropDownBtnOptionsWrap: css({ position: 'relative', marginLeft: '1rem' }),
	dropdownBtn: css({
		backgroundColor: theme.colors.background.paper,
		borderColor: theme.colors.input.border,
		paddingLeft: '0.75rem',
		paddingRight: '0.75rem',
		paddingTop: '0.25rem',
		paddingBottom: '0.25rem',
		borderWidth: '1px',
		display: 'flex',
		alignItems: 'center',
		outline: '2px solid transparent',
		outlineOffset: '2px',
		':focus': { outline: '2px solid transparent', outlineOffset: '2px' },
	}),

	dropdownList: css({
		boxShadow: '0px 4px 8px #0000001f',
		position: 'absolute',
		bottom: '0px',
		left: '0px',
		right: '0px',
		outline: '2px solid transparent',
		outlineOffset: '2px',
	}),

	openList: css({
		borderColor: theme.colors.input.border,
		borderWidth: '1px',
		outline: '2px solid transparent',
		outlineOffset: '2px',
	}),
	dropdownOption: css({ padding: '0.5rem', textAlign: 'left' }),
};

interface SidebarPaginationProps {
	totalItems?: number;
	itemType?: DataTableItemType;
	rowsPerPage: number;
	page: number;
	onChangePage: (newPage: number) => void;
	isLoading: boolean;
}

export function SidebarPagination({
	rowsPerPage,
	totalItems,
	page,
	onChangePage,
	itemType,
	isLoading,
}: SidebarPaginationProps) {
	return (
		<div css={styles.container}>
			{isLoading ? null : (
				<>
					<div css={styles.buttonsWrap}>
						<ListPaginationTotal
							totalItems={totalItems}
							itemType={itemType}
							sidebarView
						/>
					</div>
					<ListPageSelector
						totalItems={totalItems}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={onChangePage}
						delta={0}
					/>
				</>
			)}
		</div>
	);
}
